<template>
    <div>
        <button @click="loginWithToken">Test login with token</button>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
import RequestManager from '../script/request';
    export default defineComponent({
        methods: {
            test() {
                console.log("tu a cliquer sur test");
                console.log(JSON.stringify({ x: 5, y: 6 }));
            },
            loginWithToken() {
                const url = 'https://localhost:44340/api/Client/connexionWithToken';
                RequestManager.post(url, {})
                    .then(response => {
                        console.log("response loginWithToken = ", response);
                    })
                    .catch(error => {
                        console.error("error on loginWithToken = ", error)
                    });
            }
        }
    });
</script>
